import _ from 'lodash';
import {
  IOption,
  IVariant,
  CustomVariantValues,
  CustomProductItem,
} from '../type';

const compareOptionsChanged = (
  options: IOption[] = [],
  variants: IVariant<CustomVariantValues, CustomProductItem>[] = [],
) => {
  const _v = _.cloneDeep(variants);
  const mappedOptions = options.reduce((pre, now) => {
    const { id } = now;
    return { ...pre, [id]: now };
  }, {});
  return _v.map((v) => {
    const { values, ...rest } = v;
    const newValues = Object.keys(values).reduce((pre, id) => {
      if (mappedOptions[id]) {
        const selectedVariantValue = v.values[id].value;
        const option: IOption = mappedOptions[id];
        const { values: optionValues } = option;
        mappedOptions[id].marked = true;
        if (!optionValues.includes(selectedVariantValue)) {
          //values[value]=null
          return { ...pre, [id]: { value: null } };
        } else {
          return { ...pre, [id]: { value: selectedVariantValue } };
        }
      }
      return pre;
    }, {});
    const _mappedOptionsValues = Object.values(mappedOptions).filter(
      (i: any) => !i.marked,
    );
    if (_mappedOptionsValues.length > 0) {
      _mappedOptionsValues.forEach((i: IOption) => {
        const { id } = i;
        newValues[id] = { value: null };
      });
    }
    return { ...rest, values: newValues };
  });
};
export const variantsAfterOptionsHasChanged = (
  options: IOption[] = [],
  variants: IVariant<CustomVariantValues, CustomProductItem>[] = [],
) => {
  return compareOptionsChanged(options, variants);
};
// export const productInfoCheck = (info) => {
//   const _i = _.cloneDeep(info);
//   let flag;
//   if (!_i.name) {
//     _i[generateErrorKey('name')] = true;
//     flag = true;
//   }
//   return { data: info, flag };
// };
// export const variantProductCheck = (
//   variants: IVariant<CustomVariantValues, CustomProductItem>[],
// ) => {
//   const _variants = _.cloneDeep(variants);
//   let flag;
//   _variants.forEach((variant) => {
//     const { product, values } = variant;
//     const { name } = product;
//     if (!name) {
//       variant.product[generateErrorKey('name')] = true;
//       flag = true;
//     }
//     Object.keys(values).forEach((key) => {
//       if (!values[key].value) {
//         values[key][generateErrorKey('value')] = true;
//         flag = true;
//       }
//     });
//   });
//   const isEmpty = _variants.length;
//   return { data: _variants, flag, isEmpty };
// };
